import React, { useState } from 'react';
import { bool, func, object, string } from 'prop-types';
import classnames from 'classnames';
import { Toggle, Tooltip } from 'ps-design';
import './SettingsCard.scss';

const DISABLED_SETTING_TEXT = 'Not available for apply geo differentials';

SettingsCard.propTypes = {
  className: string,
  containerClass: string,
  customSettingToggle: func,
  disabled: bool,
  id: string,
  setting: object,
  title: string,
  toggle: bool
};

function SettingsCard(props) {
  const { className, containerClass, customSettingToggle, disabled, id, setting, title, toggle } = props;
  const [settingCollapse, setSettingCollapse] = useState(false);

  return (
    <div className={classnames('data-setting__container', { [containerClass]: containerClass })}>
      <div className={classnames('data-setting__header', { 'disabled-header': disabled })}>
        {disabled ? (
          <Tooltip
            display="underline"
            tooltipText={title}
            hoverText={DISABLED_SETTING_TEXT}
            id={`group-by-tooltip`}
            position="right"
          />
        ) : (
          <h4 className="data-setting__title">{title}</h4>
        )}
        {id !== 'family' ? (
          <i
            className={settingCollapse ? 'icon-down-open' : 'icon-up-open'}
            onClick={() => setSettingCollapse(!settingCollapse)}
          />
        ) : (
          <Toggle
            className={classnames('family-toggle', { 'disabled-toggle': disabled })}
            id="family-toggle__details"
            onChange={disabled ? null : () => customSettingToggle(!toggle)}
            value={toggle}
          />
        )}
      </div>
      <div
        className={classnames('data-setting__content', {
          [className]: className,
          collapsed: customSettingToggle ? !toggle : settingCollapse
        })}
      >
        {setting}
      </div>
    </div>
  );
}

export default SettingsCard;
